import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M24 29.833c-2.711 0-4.91-2.089-4.91-4.666S21.29 20.5 24 20.5s4.91 2.09 4.91 4.667-2.199 4.666-4.91 4.666m0-1.5c1.9 0 3.41-1.435 3.41-3.166C27.41 23.435 25.9 22 24 22s-3.41 1.435-3.41 3.167 1.51 3.166 3.41 3.166",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M35.046 34.5c1.355 0 2.454-1.045 2.454-2.333V19.333c0-1.288-1.099-2.333-2.455-2.333h-4.909l-2.454-3.5h-7.364L17.864 17h-4.91C11.6 17 10.5 18.045 10.5 19.333v12.834c0 1.288 1.099 2.333 2.454 2.333zm-16.402-16 2.454-3.5h5.804l2.454 3.5h5.69c.543 0 .954.39.954.833v12.834c0 .442-.41.833-.955.833h-22.09c-.544 0-.955-.39-.955-.833V19.333c0-.442.41-.833.954-.833z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M46.75 11.863s-1.544-7.377-8.214-9.969C35.35.648 29.626.05 24 0 18.375.05 12.65.648 9.514 1.844 2.843 4.436 1.3 11.813 1.3 11.813.304 16-.045 20.236.005 23.975-.045 27.763.255 32 1.3 36.187c0 0 1.543 7.376 8.214 9.968C12.65 47.352 18.374 47.95 24 48c5.625-.05 11.35-.599 14.486-1.845 6.671-2.592 8.214-9.968 8.214-9.968.996-4.187 1.345-8.424 1.295-12.162.05-3.788-.25-8.025-1.245-12.162M24.013 1.5c5.895.052 11.2.705 13.98 1.792 2.075.806 3.734 2.193 5.033 4.014a15 15 0 0 1 1.795 3.39c.259.686.405 1.207.461 1.474.892 3.709 1.267 7.698 1.213 11.835.053 3.992-.354 8.048-1.254 11.835-.065.307-.212.827-.47 1.513a15 15 0 0 1-1.795 3.39c-1.299 1.822-2.958 3.208-5.033 4.014-2.696 1.071-7.912 1.689-13.956 1.743-5.854-.053-11.19-.697-13.939-1.746-2.066-.803-3.726-2.19-5.024-4.01a15 15 0 0 1-1.795-3.39c-.259-.687-.405-1.207-.461-1.475-.933-3.742-1.318-7.71-1.263-11.884C1.452 20 1.86 15.944 2.76 12.16c.065-.308.211-.828.47-1.514a15 15 0 0 1 1.795-3.39c1.298-1.821 2.958-3.207 5.033-4.014 2.741-1.045 8.077-1.69 13.956-1.742",
      clipRule: "evenodd"
    }
  )
);
var SvgAddPhotoOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AddPhotoOutlined_default = SvgAddPhotoOutlined;

export { AddPhotoOutlined_default as default };
